import React from "react"
import { ContactTableFragment } from "~/__generated__/graphql"
import { Button } from "~/ui/button"

interface ContactCSVExportProps {
  contacts: ContactTableFragment[]
  fileName?: string
  disabled?: boolean
}

export function ContactCSVExport({
  contacts,
  fileName = "contacts",
  disabled = false,
}: ContactCSVExportProps) {
  const generateCSV = () => {
    const headers = [
      "First Name",
      "Last Name",
      "Handle",
      "Email 1",
      "Email 2",
      "Email 3",
      "Phone 1",
      "Phone 2",
      "Phone 3",
      "Wallet ID 1",
      "Wallet ID 2",
      "Wallet ID 3",
      "Tags",
    ]

    const csvData = contacts.map((contact) => {
      const user = contact.user
      const wallets = user.wallets || []
      const emails = user.emails || []
      const phones = user.phones || []
      const tags = contact.tags || []
      const tagNames = tags.map((tag) => tag.name).join(", ")

      return [
        user.firstName || "",
        user.lastName || "",
        user.handle || "",
        emails[0]?.email || "",
        emails[1]?.email || "",
        emails[2]?.email || "",
        phones[0]?.phoneFormatted || "",
        phones[1]?.phoneFormatted || "",
        phones[2]?.phoneFormatted || "",
        wallets[0]?.publicKey || "",
        wallets[1]?.publicKey || "",
        wallets[2]?.publicKey || "",
        tagNames,
      ]
    })

    const csvContent = [
      headers.join(","),
      ...csvData.map((row) =>
        row
          .map((field) => {
            // Escape fields that contain commas, quotes, or newlines
            if (field.includes(",") || field.includes('"') || field.includes("\n")) {
              return `"${field.replace(/"/g, '""')}"`
            }
            return field
          })
          .join(",")
      ),
    ].join("\n")

    return csvContent
  }

  const downloadCSV = () => {
    try {
      const csvContent = generateCSV()
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
      const link = document.createElement("a")

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)
        link.setAttribute("href", url)
        link.setAttribute("download", `${fileName}.csv`)
        link.style.visibility = "hidden"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }
    } catch (error) {
      console.error("Error generating CSV:", error)
    }
  }

  return (
    <Button variant="secondary" onClick={downloadCSV} disabled={disabled || contacts.length === 0}>
      Export CSV
    </Button>
  )
}
